
export default {
  quotes: []
}
